import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import ga from 'react-ga';
import { decline } from 'core/utils';
import { CargoType, CategoryType } from 'types';
import IconSVG from 'svg-inline-react';
import ActionCreators from 'actions/ActionCreators';
import CargosConstants from 'constants/Cargos';
import CategoryStore from 'stores/CategoryStore';
import CategoryIcon from 'components/CategoryIcon';
import { translate as t } from 'lang';

import './Cargo.scss';

class Attributes extends Component {

    static propTypes = {
        cargo: PropTypes.instanceOf(CargoType).isRequired,
        selectedCategory: PropTypes.instanceOf(CategoryType),
    };

    constructor(props) {
        super(props);
    }

    renderSizeLine() {
        if (this.props.selectedCategory.get('name') === 'animals') {
            return null;
        }

        var attributes = this.props.cargo.attributes.toJS();
        var massUnit = 'кг';
        var sizeUnit = 'см';
        var params = [];

        if (attributes.unit_of_measurement && attributes.unit_of_measurement.value && attributes.unit_of_measurement.value[0] === CargosConstants.UNITS.M) {
            massUnit = 'т';
            sizeUnit = 'м';
        }

        if (attributes.length && attributes.length.value) {
            params.push(
                <span key="length">
                    {attributes.length.value} {sizeUnit}
                </span>
            );
        }
        if (attributes.width && attributes.width.value) {
            params.push(
                <span key="width">
                    {attributes.width.value} {sizeUnit}
                </span>
            );
        }
        if (attributes.height && attributes.height.value) {
            params.push(
                <span key="height">
                    {attributes.height.value} {sizeUnit}
                </span>
            );
        }

        for (var i = 0; i < params.length; i++) {
            if (params.length > i + 1) {
                i++;
                params.splice(i, 0, <span key={"div" + i.toString()}> x </span>);
            }
        }

        if (attributes.volume && attributes.volume.value) {
            var volume = attributes.volume.value;
            if (attributes.unit_of_measurement.value && attributes.unit_of_measurement.value[0] === CargosConstants.UNITS.CM) {
                volume /= 1e6;

                if (volume < 0.01) {
                    volume = 0.01;
                }
            }
            if (params.length > 0) {
                params.push(<span key={"div" + params.length.toString()}> | </span>);
            }
            params.push(<span key="volume">{Math.round(volume * 100) / 100} м³</span>);
        }

        if (attributes.weight && attributes.weight.value) {
            var weight = attributes.weight.value;
            if (params.length > 0) {
                params.push(<span key={"div" + params.length.toString()}> | </span>);
            }
            params.push(<span key="weight">{weight} {massUnit}</span>);
        }
        if (attributes.number_of_persons && attributes.number_of_persons.value) {
            params.push(
                <span key="number_of_persons">
                    {attributes.number_of_persons.value} {decline(attributes.number_of_persons.value, ['человек', 'человека', 'человек'])}
                </span>
            );
        }
        if (attributes.number_of_hours && attributes.number_of_hours.value) {
            if (params.length > 0) {
                params.push(<span key={"div" + params.length.toString()}> | </span>);
            }
            params.push(
                <span key="number_of_hours">
                    {attributes.number_of_hours.value} {decline(attributes.number_of_hours.value, ['час', 'часа', 'часов'])}
                </span>
            );
        }

        if (params.length == 0) {
            return null;
        }

        return (
            <p className="Cargo-propertiesLine">{params}</p>
        );
    }

    renderOptionalLine() {
        var attributes = this.props.cargo.attributes.toJS();
        var optionalValues = [];

        if (attributes.disassembly && attributes.disassembly.value) {
            optionalValues.push(attributes.disassembly.title);
        }

        if (attributes['not_fit_elevator'] && attributes['not_fit_elevator'].value) {
            optionalValues.push(attributes['not_fit_elevator'].title);
        }

        if (attributes.is_working) {
            if (attributes.is_working.value) {
                optionalValues.push("На ходу");
            } else {
                optionalValues.push("Не на ходу");
                if (attributes['wheels_are_spinning']) {
                    optionalValues.push((attributes['wheels_are_spinning'].value ? "Колёса крутятся" : "Колёса не крутятся"));
                }
            }
        }

        if (optionalValues.length == 0) return null;
        return (
            <p className="Cargo-propertiesLine">{optionalValues.join(', ')}</p>
        );
    }

    render() {
        return (
            <div className="Cargo-properties">
                {this.renderSizeLine()}
                {this.renderOptionalLine()}
            </div>
        );
    }

}

class Cargo extends Component {

    static propTypes = {
        cargo: PropTypes.instanceOf(CargoType).isRequired,
        id: PropTypes.number.isRequired,
        selectedCategory: PropTypes.instanceOf(CategoryType),
    };

    state = {
        controlsActive: false
    };

    componentDidMount() {
        window.addEventListener('mouseup', this._handleOuterClick);
    }

    componentWillUnmount() {
        window.removeEventListener('mouseup', this._handleOuterClick);
    }

    _onEditClick = () => {

        ga.event({
            category: 'clicks',
            action: 'click_button_edit_cargo_booking_step_2',
            label: CategoryStore.getSelected().name,
            value: 1
        });

        ActionCreators.startCargoEditing(this.props.cargo, this.props.id, true);
    };

    _onRemoveClick = () => {
        if (confirm(t('REALLY_WANT_TO_REMOVE_CARGO'))) {
            ga.event({
                category: 'clicks',
                action: 'click_button_delete_cargo_booking_step_2',
                label: CategoryStore.getSelected().name,
                value: 1
            });

            ActionCreators.removeCargo(this.props.id);
        }
    };

    _handleOuterClick = (event) => {
        if (event.target !== this.refs.controlsButton) {
            this.setState({
                controlsActive: false
            });
        }
    };

    _toggleControls = () => {
        this.setState({
            controlsActive: !this.state.controlsActive
        });
    };

    renderCargoName() {
        var attributes = this.props.cargo.attributes.toJS();
        var cargoName;
        var cargoAmount = null;

        if (attributes.name) {
            cargoName = attributes.name.value;
        } else if (attributes.auto_brand && attributes.auto_model) {
            cargoName = attributes.auto_brand.value + " " + attributes.auto_model.value;
        } else {
            cargoName = this.props.cargo.get('name');
        }

        if (attributes.quantity) {
            cargoName += ': ';
            cargoAmount = (
                <span className="Cargo-amount">
                    {(attributes.quantity.value || 1) + ' шт'}
                </span>
            );
        }

        return (
            <div className="Cargo-name">
                {cargoName}
                {cargoAmount}
            </div>
        );
    }

    renderPhoto() {
        var attributes = this.props.cargo.get('attributes');
        var categoryId = CategoryStore.getSelected().id;

        var photoClass = ['Cargo-photo'];
        var photoList = attributes.getIn(['photo', 'value']);
        if (!photoList) photoList = [];

        var photo;
        if (photoList.length == 0) {
            photoClass.push("Cargo-photo--default");
            photo = <CategoryIcon category={categoryId} />;
        } else {
            photo = <img src={photoList[0]} alt="" />;
        }

        return (
            <div className={photoClass.join(' ')}>{photo}</div>
        );
    }

    render() {
        var controlsActive = this.state.controlsActive;
        var controlButtonClass = classNames([
            'Cargo-controlsButton',
            {
                '-active': controlsActive
            }
        ]);

        return (
            <div className="Cargo">
                <div className={controlButtonClass}
                    ref="controlsButton"
                    onClick={this._toggleControls}>
                    &#8942;
                </div>
                <div className="Cargo-controls"
                    ref="controls">
                    <div className="Cargo-edit"
                        onClick={this._onEditClick}>
                        <IconSVG className="Cargos-editIcon"
                            src={require('!svg-inline!./pen.svg')}
                            title="Редактировать груз" />
                    </div>
                    <div className="Cargo-remove"
                        onClick={this._onRemoveClick}>
                        <IconSVG className="Cargos-removeIcon"
                            src={require('!svg-inline!./trash.svg')}
                            title="Удалить груз" />
                    </div>
                </div>
                {this.renderPhoto()}
                {this.renderCargoName()}
                <Attributes cargo={this.props.cargo}
                    selectedCategory={this.props.selectedCategory} />
                <div className="Cargo__end"></div>
            </div>
        );
    }
}

export default Cargo;



// WEBPACK FOOTER //
// ./client/components/Cargo/Cargo.js